import { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRuleByIdAsync, updateRuleAsync } from "../../Helpers/API/RuleApi";
import RuleForm from "./RuleForm";

const UpdateRule = () => {
	const navigate = useNavigate();
	const { id } = useParams();

	const [formValues, setFormValues] = useState({
		name: "",
		field: "",
		operator: "",
		value: "",
		displayValue: "",
	});

	const onSubmit = (ruleObject) => {
		async function updateRule() {
			const success = await updateRuleAsync(id, ruleObject);
			if (success) navigate("/rules");
		}
		updateRule();
	};

	useEffect(() => {
		async function getRule() {
			const { name, field, operator, value, displayValue } = await getRuleByIdAsync(id);
			setFormValues({
				name,
				field,
				operator,
				value,
				displayValue,
			});
		}
		getRule();
	}, [id]);

	return (
		<div>
			<div className="breadcrumbs">
				<Breadcrumb>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						Home
					</Breadcrumb.Item>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/rules" }}>
						Rules
					</Breadcrumb.Item>
					<Breadcrumb.Item active>Update Rule</Breadcrumb.Item>
				</Breadcrumb>
			</div>
			<RuleForm initialValues={formValues} saveText="Update rule" headerText="Update an existing rule" onSubmit={onSubmit} />
		</div>
	);
};

export default UpdateRule;
